import { PRESCREENER_RESET_OBJECT } from 'client-portal/utils/prescreener/constants';
import { STEP_IDS } from 'client-portal/services/widget-steps';
import Super from './prescreener--base-category';

export default class RequestPrescreenerReasonForCare extends Super {
  stepId = STEP_IDS.PRESCREENER_REASON_FOR_CARE;

  get getResetKeys() {
    return PRESCREENER_RESET_OBJECT;
  }
}
